import type { Locale } from '@jotta/i18n'
import { MediamarktTermsES } from './MediamarktTermsES'
import { MediamarktTermsEN } from './MediamarktTermsEN'
import { MediamarktTermsFR } from './MediamarktTermsFR'
import { MediamarktTermsNL } from './MediamarktTermsNL'
import { ProseContainer } from '../components/ProseContainer'
import { MediamarktTermsDE } from './MediamarktTermsDE'

function MediamarktTermsSwitch({ locale }: { locale: Locale }) {
  switch (locale) {
    case 'de':
      return <MediamarktTermsDE />
    case 'nl':
      return <MediamarktTermsNL />
    case 'fr':
      return <MediamarktTermsFR />
    case 'es':
      return <MediamarktTermsES />
    default:
      return <MediamarktTermsEN />
  }
}

export function MediamarktTerms({ locale }: { locale: Locale }) {
  return (
    <ProseContainer>
      <MediamarktTermsSwitch locale={locale} />
    </ProseContainer>
  )
}
